/**
 *
 * @param {string} createdAt
 * @returns {number}
 */
export function createdAtToTimestamp(createdAt) {
  return new Date(createdAt).getTime()
}
